import { render, staticRenderFns } from "./FooterComponent.vue?vue&type=template&id=6ef9f99e&scoped=true"
import script from "./FooterComponent.js?vue&type=script&lang=js&external"
export * from "./FooterComponent.js?vue&type=script&lang=js&external"
import style0 from "./FooterComponent.vue?vue&type=style&index=0&id=6ef9f99e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef9f99e",
  null
  
)

export default component.exports